import { Update } from '@ngrx/entity';
import { Action } from '@ngrx/store';
import { ApproachTypeNgrx } from './approach-type.model';

export enum ApproachTypeActionTypes {
  LoadApproachTypes = '[ApproachType] Load ApproachTypes',
  AddApproachType = '[ApproachType] Add ApproachType',
  UpsertApproachType = '[ApproachType] Upsert ApproachType',
  AddApproachTypes = '[ApproachType] Add ApproachTypes',
  UpsertApproachTypes = '[ApproachType] Upsert ApproachTypes',
  UpdateApproachType = '[ApproachType] Update ApproachType',
  UpdateApproachTypes = '[ApproachType] Update ApproachTypes',
  DeleteApproachType = '[ApproachType] Delete ApproachType',
  DeleteApproachTypes = '[ApproachType] Delete ApproachTypes',
  ClearApproachTypes = '[ApproachType] Clear ApproachTypes',
}

export class LoadApproachTypes implements Action {
  public readonly type = ApproachTypeActionTypes.LoadApproachTypes;

  constructor(public payload: { approachTypes: ApproachTypeNgrx[] }) {}
}

export class AddApproachType implements Action {
  public readonly type = ApproachTypeActionTypes.AddApproachType;

  constructor(public payload: { approachType: ApproachTypeNgrx }) {}
}

export class UpsertApproachType implements Action {
  public readonly type = ApproachTypeActionTypes.UpsertApproachType;

  constructor(public payload: { approachType: ApproachTypeNgrx }) {}
}

export class AddApproachTypes implements Action {
  public readonly type = ApproachTypeActionTypes.AddApproachTypes;

  constructor(public payload: { approachTypes: ApproachTypeNgrx[] }) {}
}

export class UpsertApproachTypes implements Action {
  public readonly type = ApproachTypeActionTypes.UpsertApproachTypes;

  constructor(public payload: { approachTypes: ApproachTypeNgrx[] }) {}
}

export class UpdateApproachType implements Action {
  public readonly type = ApproachTypeActionTypes.UpdateApproachType;

  constructor(public payload: { approachType: Update<ApproachTypeNgrx> }) {}
}

export class UpdateApproachTypes implements Action {
  public readonly type = ApproachTypeActionTypes.UpdateApproachTypes;

  constructor(public payload: { approachTypes: Update<ApproachTypeNgrx>[] }) {}
}

export class DeleteApproachType implements Action {
  public readonly type = ApproachTypeActionTypes.DeleteApproachType;

  constructor(public payload: { id: string }) {}
}

export class DeleteApproachTypes implements Action {
  public readonly type = ApproachTypeActionTypes.DeleteApproachTypes;

  constructor(public payload: { ids: string[] }) {}
}

export class ClearApproachTypes implements Action {
  public readonly type = ApproachTypeActionTypes.ClearApproachTypes;
}

export type ApproachTypeActions =
  | LoadApproachTypes
  | AddApproachType
  | UpsertApproachType
  | AddApproachTypes
  | UpsertApproachTypes
  | UpdateApproachType
  | UpdateApproachTypes
  | DeleteApproachType
  | DeleteApproachTypes
  | ClearApproachTypes;
